export const FRANCHISE_LABELS = {
    1: {
        theme: 'mint',
        title: 'Выбор',
    },
    2: {
        theme: 'yellow',
        title: 'Партнер',
    },
};
